import * as React from "react";
import type { SVGProps } from "react";
const SvgDownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="download_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m610.56 737.579-55.083 55.466V554.411a42.667 42.667 0 0 0-85.418 0v238.634l-55.083-55.466a42.88 42.88 0 0 0-60.672 60.586l128.128 128.128a42.667 42.667 0 0 0 14.08 8.96 40.107 40.107 0 0 0 32.47 0 42.667 42.667 0 0 0 14.08-8.96l128.127-128.085a42.837 42.837 0 1 0-60.586-60.63zm176.384-472.662a298.88 298.88 0 0 0-486.699-90.837 298.837 298.837 0 0 0-83.882 171.605 170.837 170.837 0 0 0-73.472 293.888 170.88 170.88 0 0 0 113.621 42.966 42.71 42.71 0 1 0 0-85.419 85.419 85.419 0 1 1 0-170.752 42.71 42.71 0 0 0 42.71-42.667 213.419 213.419 0 0 1 178.687-210.176 213.59 213.59 0 0 1 236.843 141.398 42.667 42.667 0 0 0 33.323 28.586 128.128 128.128 0 0 1 10.24 249.387 42.752 42.752 0 1 0 21.333 82.773 213.547 213.547 0 0 0 118.059-332.074 213.504 213.504 0 0 0-110.763-78.635z"
    />
  </svg>
);
export default SvgDownloadIcon;
